<template>
  <div>
   <div><van-nav-bar title="MCDEX时讯" left-text="返回" left-arrow @click-left="onClickLeft"></van-nav-bar></div>
   <!-- <div class="divclass">
       <van-field v-model="url" label="仅IP地址：" placeholder="输入IP"/>
       <van-switch class="kg" v-model="checked" :size=20 @change="change" active-color="#07c160" inactive-color="#F2EEEE"/>
   </div> -->
   <div class="divclass">
       <!-- <span style="font-size:0.16rem;">服务器地址</span> -->
       <van-field v-model="url" label="服务器地址：" placeholder="请输入"/>
       <div class="sm" @click="scanQrCode">二维码</div>
   </div>
   <div class="urlclass">
       <span>设置结果</span>
       <!-- <div>{{url}}</div> -->
       <!-- <span v-if="checked">{{prefix}}</span>
       <span style="color:#5471BB">{{url}}</span>
       <span v-if="checked">{{suffix}}</span> -->
   </div>
   <div class="urlclass">{{url}}</div>
   <!-- <label style="font-size:0.14rem">{{saveSuccessMsg}}</label> -->
   <div class="save" @click="save">保存设置</div>
  </div>
</template>

<script>
import errImg from "@/assets/net_err.png";
export default {
  name: 'HelloWorld',  
  data () {
    return {
      errImg: errImg,
      url: "",//服务器IP
      prefix: "http://",
      suffix: "/pc/mobile",
      onlyip: true,
      saveSuccessMsg: "",
      showSet: true,
      iniErr: "",
      origUrl: "",
      checked:true,
    }
  },
  created(){
      
  },
  methods:{    
    onClickLeft(){
      this.$router.push({ name: "Scan" });
    },
    scanQrCode() {
      location.href =
      "McCoreAction:" +
      JSON.stringify({
          method: "scanQrCode",
          callback: "window.scanQrCode_callback"
      });
    },
    change() {
      this.url = "";
    },
    save() {
        // if(this.checked){
        //     location.href =
        //     "McCoreAction:" +
        //     JSON.stringify({ method: "SetServerUrl", params: this.prefix+this.url+this.suffix });
        // }else{
        //   // console.log(this.url)
        //     location.href =
        //     "McCoreAction:" +
        //     JSON.stringify({ method: "SetServerUrl", params: this.url });
        // }
      location.href =
            "McCoreAction:" +
            JSON.stringify({ method: "SetServerUrl", params: this.url });
      this.saveSuccessMsg = "设置成功，下次打开APP将转到您设置的地址";
      this.$toast(this.saveSuccessMsg);
    },
  },
  mounted() {
    var _this = this;
    window.scanQrCode_callback = function(qrCode) {
      if (!!qrCode) {
        // _this.checked = false;
        _this.url = decodeURIComponent(qrCode);
      }
    };
    window.refresh_callback = function(url) {
      url = decodeURIComponent(url);
      location.replace(url);
    };

    var arr = location.href.split("?");
    if (arr.length > 1) {
      var query = arr[1];
      var _arr = query.split("=");
      if (_arr.length > 1 && _arr[0].indexOf("errmsg") !== 1) {
        var errmsg = _arr[1].replace(/[#\/]+$/g, "");
        errmsg = decodeURIComponent(errmsg);
        _this.iniErr = errmsg;

        _this.origUrl = _this.getUrl(errmsg);
        _this.showSet = false;
        _this.HeaderTitle = "访问页面出错";
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.divclass{
    padding: 0.1rem 0.1rem 0 0.1rem;
    font-size: 0.14rem;
    height: 0.45rem;
    line-height: 0.45rem;
    border-bottom: 0.01rem solid #EAE1E1;
    overflow: hidden;
}
.kg{
    margin-top: 0.1rem;
    float: right;
}
.sm{
    font-size: 0.14rem;
    background: #07c160;
    color: #fff;
    text-align: center;
    height: 0.3rem;
    line-height: 0.3rem;
    border-radius: 0.05rem;
    width: 0.55rem;
    float: right;
    margin-top: 0.08rem;
}
.save{
    font-size: 0.16rem;
    background: #07c160;
    color: #fff;
    text-align: center;
    height: 0.4rem;
    line-height: 0.4rem;
    border-radius: 0.2rem;
    width: 80%;
    margin-left: 10%;
    margin-top: 30%;
}
.van-cell {
    float: left;
    padding: 0;
    width: 80%;
    line-height: 0.45rem;

}
.urlclass{
  font-size: 0.14rem;
  word-break: break-all;
  padding: 0.1rem 0.12rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ScanDetail.vue